/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'

const Dropdown2: FC = () => {
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px'
      data-kt-menu='true'
    >
      <div className='px-3 menu-item'>
        <div className='py-4 px-3 menu-content fs-6 text-dark fw-bolder'>Quick Actions</div>
      </div>

      <div className='mb-3 opacity-75 separator'></div>

      <div className='px-3 menu-item'>
        <a href='#' className='px-3 menu-link'>
          New Ticket
        </a>
      </div>

      <div className='px-3 menu-item'>
        <a href='#' className='px-3 menu-link'>
          New Customer
        </a>
      </div>

      <div
        className='px-3 menu-item'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='right-start'
        data-kt-menu-flip='left-start, top'
      >
        <a href='#' className='px-3 menu-link'>
          <span className='menu-title'>New Group</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='py-4 menu-sub menu-sub-dropdown w-175px'>
          <div className='px-3 menu-item'>
            <a href='#' className='px-3 menu-link'>
              Admin Group
            </a>
          </div>

          <div className='px-3 menu-item'>
            <a href='#' className='px-3 menu-link'>
              Staff Group
            </a>
          </div>

          <div className='px-3 menu-item'>
            <a href='#' className='px-3 menu-link'>
              Member Group
            </a>
          </div>
        </div>
      </div>

      <div className='px-3 menu-item'>
        <a href='#' className='px-3 menu-link'>
          New Contact
        </a>
      </div>

      <div className='mt-3 opacity-75 separator'></div>

      <div className='px-3 menu-item'>
        <div className='py-3 px-3 menu-content'>
          <a className='px-4 btn btn-primary  btn-sm' href='#'>
            Generate Reports
          </a>
        </div>
      </div>
    </div>
  )
}

export {Dropdown2}
